
<template>
  <CModal
     :title="'編集'"
     color="dark"
     :show.sync="recordModal"
     :closeOnBackdrop=false
   >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">名</label>
           <CInput
             placeholder=""
             v-model="record.first_name"
             required
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">ミドルネーム</label>
           <CInput
             placeholder=""
             v-model="record.sur_name"
             required
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">姓</label>
           <CInput
             placeholder=""
             v-model="record.last_name"
             required
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">ステータス</label>
           <CSelect
             placeholder="ユーザーの会員を選択"
             :options="states"
             :value.sync="record.status"
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">性別</label>
           <CSelect
             placeholder="性別を選択してください"
             :options="genderSelect"
             :value.sync="record.gender"
           />
         </CCol>
       </CRow>

       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">電話番号</label>
           <CInput
             placeholder=""
             v-model="record.phone"
             required
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">LINE ID</label>
           <CInput
             placeholder=""
             v-model="record.line_id"
             required
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label">現在勉強している業種</label>
          <CSelect
            placeholder="問題の業種を選択してください"
            :options="industryTypes"
            :value.sync="record.current_industry"
          />
        </CCol>
      </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">国籍</label>
           <CSelect
             placeholder="国籍を選択してください"
             :options="nationalityArr"
             :value.sync="record.nationality"
           />

         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">言語</label>
           <CSelect
             placeholder="言語を選択してください"
             :options="languageArr"
             :value.sync="record.language"
           />

         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">受講業種</label>
           <CSelect
             placeholder="受講業種を選択してください"
             :options="industryTypes"
             :value.sync="record.course_industry"
           />

         </CCol>
       </CRow>

       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">試験受講日</label>
           <CInput
             placeholder=""
             type='date'
             v-model="record.exam_date"
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">試験受講結果</label>
           <CSelect
             placeholder="試験受講結果を選択してください"
             :options="examResultStates"
             :value.sync="record.exam_result"
           />

         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">試験結果</label>
           <CSelect
             placeholder="試験結果を選択してください"
             :options="examPassResultStates"
             :value.sync="record.exam_pass_result"
           />

         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">ビザ申請状況</label>
           <CSelect
             placeholder="ビザ申請状況を選択してください"
             :options="visaApplicationStatusStates"
             :value.sync="record.visa_application_status"
           />

         </CCol>
       </CRow>

        <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">就業希望企業名</label>
           <CInput
             placeholder=""
             v-model="record.employment_hope_company"
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">就業状況</label>
           <CInput
             placeholder=""
             v-model="record.employment_status"
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">マッチング先企業</label>
           <CInput
             placeholder=""
             v-model="record.matching_company"
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">入社日</label>
           <CInput
             placeholder=""
             type='date'
             v-model="record.workday"
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">退社日</label>
           <CInput
             placeholder=""
             type='date'
             v-model="record.leave_date"
           />
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">特定技能VISA申請日</label>
           <CInput
             placeholder=""
             type='date'
             v-model="record.specific_skills_visa_application_date"
           />
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(itemIndex)">登録</CButton>
       </template>
   </CModal>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
export default {
  name: '',
  props: {
    record:{},
    recordModal: {
      type: Boolean,
      default: false
    },
    industryTypes: []
  },
  data() {
    return {
      options: [],
      memberDic: {"associate_member": "仮登録", "no_deposite_member": "本登録(未入金)", "member": "本登録"},
      nationalityArr: [
        "ベトナム",
        "ラオス",
        "マレーシア",
        "バングラデッシュ",
        "インド",
        "モンゴル",
        "ネパール",
        "インドネシア",
        "タイ",
        "フィリピン",
        "ミャンマー",
        "ウズベキスタン",
        "パキスタン",
        "日本"
      ],
      languageArr: [{
        value: "japanese",
        label: "日本語"
      }, {
        value: "vietnamese",
        label: "ベトナム語"
      }, {
        value: "english",
        label: "英語"
      }, {
        value: "khmer",
        label: "クメール語"
      }, {
        value: "indonesian",
        label: "インドネシア語"
      }, {
        value: "tagalog",
        label: "タガログ語"
      }, {
        value: "burmese",
        label: "ビルマ語"
      }, {
        value: "hindu",
        label: "ヒンドゥー語"
      }, {
        value: "lao",
        label: "ラーオ語"
      }, {
        value: "mongolian",
        label: "モンゴル語"
      }, {
        value: "bengali",
        label: "ベンガル語"
      }, {
        value: "nepali",
        label: "ネパール語"
      }, {
        value: "thai",
        label: "タイ語"
      }

      ],
      genderSelect: [{
        value: "woman",
        label: "女性"
      }, {
        value: "man",
        label: "男性"
      }],
      states: [
        {value: "associate_member", label: "仮登録"},
        {value: "no_deposite_member", label: "本登録(未入金)"},
        {value: "member", label: "本登録"}
      ],
      examResultStates: [
        {value: "false", label: "受講前"},
        {value: "true", label: "受講済み"}
      ],
      examPassResultStates: [
        {value: "failure", label: "不合格"},
        {value: "pass", label: "合格"}
      ],
      visaApplicationStatusStates: [
        {value: "unapplied", label: "未申請"},
        {value: "applying", label: "申請中"},
        {value: "applied", label: "申請済み"}
      ],
    }
  },
  methods: {
    hideRecordModal: function() {
      this.recordModal = false
      this.$emit('hide')
    },
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
    updateItem: function() {
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/users/" + this.record.id, {"user": this.record},{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.notifyVue("更新されました")
          this.recordModal = false
        }).catch(error => {
          console.log(error)
        })
    },
    getAnswer: function() {
      var answer = []
      if(this.record.question_type != "true_or_false") {
        this.options.forEach((k,v) => {
          if(k['is_answer']) {
            answer.push(v)
          }
        })
        answer = JSON.stringify(answer)
      } else {
        answer = this.record.answer
      }
      return answer
    }
  },
  validations: {
    record: {
      title: {required},
      question_type: {required},
      industry_id: {required},
      commentary: {required}
    }
  },
  watch: {
    record: function() {
      this.$v.record.$reset();
    },
    recordModal: function() {},
  },
   computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>

<style scoped lang="scss">

</style>
